import type { HarmonyChat } from '@rapidsos/harmony-chat';

/**
 * The package does not export its theme type, so reach it through the prop.
 * Not named ThemeProps -- that collides with the styled-components type.
 */
type HarmonyChatTheme = NonNullable<Parameters<typeof HarmonyChat>[0]['theme']>;

export const harmonyChatTheme: HarmonyChatTheme = {
  rounded: {
    sm: '5px',
    md: '5px',
    lg: '5px',
    xl: '5px',
  },
  typography: {
    h2: {
      size: '20px',
      weight: '600',
    },
  },
  dark: {
    accent: '#ffffff10',
    background: '#16222f',
    popover: '#16222f',
    foreground: '#D7E9F7',
    'primary-foreground': '#0b1928',
    'muted-foreground': '#D7E9F7',
    'accent-foreground': '#D7E9F7',
    destructive: '#E42629',
    primary: '#96CAE7',
    muted: '#194264',
    border: '#31445B',
  },
  light: {
    background: '#FFFFFF',
    popover: '#FFFFFF',
    foreground: '#20354F',
    'primary-foreground': '#ffffff',
    'muted-foreground': '#20354F',
    primary: '#177ab6',
    muted: '#DFF1FC',
    border: '#EBEBEB',
  },
};
